'use strict';
(function (angular) {
	function Controller($state, $transitions) {
		let deregisterOnSuccess;

		this.$onInit = () => {
			this.layout = this.layout || 'icons';
			this.stateParam = this.stateParam || 'view';
		};

		deregisterOnSuccess = $transitions.onSuccess({}, transition => {
			if (transition.targetState().params().hasOwnProperty(this.stateParam)) {
				this.onSelectView(transition.params()[this.stateParam]);
			}
		});

		this.$onDestroy = () => {
			deregisterOnSuccess();
		};
	}
	angular.module('PinMeTo.UI').component('pmtViewSelector', {
		templateUrl: 'pmtShared/pmtUi/ViewSelector.html',
		bindings: {
			layout: '@?',
			stateParam: '@?',
			onSelectView: '<',
			views: '<'
		},
		controller: Controller
	});

	Controller.$inject = ['$state', '$transitions'];
})(window.angular);
